import EquipmentCategories from "@/components/EquipmentCategories/index.vue";
import { Category } from "@/models/categories.model";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { SEND_JSON_STATISTICS } from "@/store/operators";
import { abacaEvent, getEventJsonData } from "@/services/statistics.service";

@Component({
  components: {
    EquipmentCategories,
  },
})
export default class AddEquipmentPage extends Vue {
  selectedFilters: Category[] = [];
  defaultConstructorItem = this.$t("components.suppliersPage.brand.default").toString();
  constructorFilter = this.defaultConstructorItem;
  constructorList: string[] = this.$t("global.constructorsList").toString().split(";");
  addEquipmentLink =
    Vue.prototype.URL_ContextPath +
    this.$t("components.suppliersPage.addEquipmentLink.href").toString();

  get categories(): Category[] {
    return store.state.globalAppDataModule.categories;
  }

  mounted(): void {
    //add default filter
    this.addFilter(this.categories[0]);
    store.dispatch(SEND_JSON_STATISTICS, getEventJsonData(abacaEvent.SUPPLIERS));
  }

  addFilter(category: Category): void {
    const categoryIndex = this.selectedFilters.indexOf(category);
    if (categoryIndex == -1) {
      this.selectedFilters.push(category);
    } else {
      this.selectedFilters.splice(categoryIndex, 1);
    }
  }

  isSelected(category: Category): boolean {
    return this.selectedFilters.indexOf(category) > -1;
  }

  get isPhone(): boolean {
    return !this.$screen.lg;
  }

  onClickToOpenPopin(): void {
    const height = 700;
    const y = window.top.outerHeight / 2 + window.top.screenY - height / 2;
    const width = 1000;
    const x = window.top.outerWidth / 2 + window.top.screenX - width / 2;
    const features = `width=${width}, height=${height}, left=${x}, top=${y}`;
    window.open(this.addEquipmentLink, "window_name", features);
  }
}
